export const clientComplaintsStore = (state: any) => state.clientComplaints;
